import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import hydraulicСalculations from "../../images/hydraulicСalculations.png";
import model3d from "../../images/model3d.png";
import labConnection from "../../images/labConnection.png";
import realTime from "../../images/realtime.gif";
import recalcModule from "../../images/recalcModule.png";

const CarouselCemLife = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Slider {...settings}>
      <div className="carousel-slide">
        <div className="carousel-slide__content">
          <div className="carousel-slide__desc">
            {/* Гидравлические расчеты */}
            <p className="product__modules-description-header">
              Hydraulic Calculations
            </p>
            {/* Расчет зависимости давлений от глубины позволяет определить «зону интереса» по ГРП. Расчет ЭЦП позволяет точно подобрать расходы для лучшего вытеснения и недопуска ГРП и многие другие расчеты. */}
            <p className="product__modules-description-text">
              Calculation of pressure dependence on depth allows determining the
              "zone of interest" for hydraulic fracturing. ECD calculation
              enables precise selection of flow rates for better displacement
              and prevention of hydraulic fracturing, along with many other
              calculations.
            </p>
          </div>
          {/* <img src={hydraulicСalculations} alt="slide-1" />*/}
        </div>
      </div>

      <div className="carousel-slide">
        <div className="carousel-slide__content">
          <div className="carousel-slide__desc">
            {/* 3D вытеснение бурового раствора */}
            <p className="product__modules-description-header">
              3D Drilling Fluid Displacement
            </p>
            {/* Наиболее точный алгоритм расчета 3D вытеснения в отрасли помогает проанализировать и предотвратить каналообразование. График концентрации жидкостей в зоне интереса позволяет поставить тесты на совместимость для понимания реального состояния жидкостей в скважине. */}
            <p className="product__modules-description-text">
              The industry's most accurate 3D displacement calculation algorithm
              helps analyze and prevent channeling. The fluid concentration
              graph in the zone of interest allows running compatibility tests
              to understand the actual state of fluids in the well.
            </p>
          </div>
          {/*<img src={model3d} alt="slide-2" />*/}
        </div>
      </div>

      <div className="carousel-slide">
        <div className="carousel-slide__content">
          <div className="carousel-slide__desc">
            {/* Связь с лабораторным ПО CMTest */}
            <p className="product__modules-description-header">
              Integration with CMTest Laboratory Software
            </p>
            {/* CemLife поддерживает интеграцию следующих данных в CemLife. Реологические показания, время загустевания, тесты на совместимость. использования данного модуля значительно сокращает время подготовки кейса. */}
            <p className="product__modules-description-text">
              CemLife supports integration of the following data: rheological
              readings, thickening time, compatibility tests. Using this module
              significantly reduces case preparation time.
            </p>
          </div>
          {/*<img src={labConnection} alt="slide-3" />*/}
        </div>
      </div>

      <div className="carousel-slide">
        <div className="carousel-slide__content">
          <div className="carousel-slide__desc">
            {/* Модуль "Модуль Потоковых вычислений" */}
            <p className="product__modules-description-header">
              "Stream Computing" Module
            </p>
            {/* Предоставляет возможность подключения к цементировочным агрегатам и считывание данных в режиме реального времени. */}
            <p className="product__modules-description-text">
              Provides the ability to connect to cementing units and read data
              in real-time.
            </p>
          </div>
          {/*<img src={realTime} alt="slide-4" />*/}
        </div>
      </div>

      <div className="carousel-slide">
        <div className="carousel-slide__content">
          <div className="carousel-slide__desc">
            {/* Модуль перерасчет */}
            <p className="product__modules-description-header">
              Recalculation Module
            </p>
            {/* Предоставляет инструменты детального анализа проведенной работы по реальным данным со скважины. Позволит повысить качество цементирования на будущих работах. */}
            <p className="product__modules-description-text">
              Provides tools for detailed analysis of completed work based on
              actual well data. Will help improve cementing quality in future
              operations.
            </p>
          </div>
          {/*<img src={recalcModule} alt="slide-4" />*/}
        </div>
      </div>
    </Slider>
  );
};

export default CarouselCemLife;
